/*
Item: prepared News Component for implementing News on start page (Dashboard.jsx)
Name: News
Format: Code/Frontend component
*/

import React, { Component } from 'react';
import { Card } from 'primereact/card';
import { Panel } from 'primereact/panel';
import MessageService from '../service/MessageService';
import * as PropTypes from 'prop-types';

class News extends Component {
  constructor(props) {
    super(props);
    this.messageService = new MessageService();

  }

  render() {
    // this.getProperties();
    const { objNews } = this.props;
    const statisticsObj = objNews.map((line) => (
      {
        subTitle: line.subTitle,
        body: line.body,
      }
    ));
    const list = statisticsObj.map((n) => (
      <Card subTitle={n.subTitle}>
        {n.body}
      </Card>
    ));
    return (
      <Panel header="Methodische und allgemeine Informationen" style={{ height: '100%' }}>
        {list}
      </Panel>
    );
  }
}

export default News;

News.propTypes = {
  objNews: PropTypes.instanceOf(Array).isRequired,
};
